import { render, staticRenderFns } from "./HeadTips.vue?vue&type=template&id=3ad0786c&scoped=true"
import script from "./HeadTips.vue?vue&type=script&lang=js"
export * from "./HeadTips.vue?vue&type=script&lang=js"
import style0 from "./HeadTips.vue?vue&type=style&index=0&id=3ad0786c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad0786c",
  null
  
)

export default component.exports